
import PropTypes from "prop-types";

import Container from "@mui/material/Container";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import typography from "assets/theme/base/typography";

function Footer({ light }) {
  const { size } = typography;

  return (
    <MDBox position="absolute" width="100%" bottom={0} py={4}>
      <Container>
        <MDBox
          width="100%"
          display="flex"
          flexDirection={{ xs: "column", lg: "row" }}
          justifyContent="space-between"
          alignItems="center"
          px={1.5}
        >
          <MDBox
            display="flex"
            justifyContent="center"
            alignItems="center"
            flexWrap="wrap"
            color={light ? "white" : "text"}
            fontSize={size.sm}
          >
            <MDTypography variant="button" fontWeight="small">
              ساخته شده با ❤️ در <a href='https://gerafi.com' target='_blank' rel="noopener noreferrer" style={{ color: '#3ecddb', fontWeight: 'bold' }}>گرافی دات کام</a>
            </MDTypography>
          </MDBox>
        </MDBox>
      </Container>
    </MDBox>
  );
}


export default Footer;
